import { render, staticRenderFns } from "./HolidaysPlans.vue?vue&type=template&id=505e868f&"
import script from "./HolidaysPlans.vue?vue&type=script&lang=js&"
export * from "./HolidaysPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports